import {Component, inject} from '@angular/core';
import { Subject } from 'rxjs';
import {NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router} from "@angular/router";

export const PROGRESS_BAR_SUBJECT = new Subject<boolean>();

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  public callInProgress: boolean = false;
  public isRouteLoading: boolean = true;

  private readonly router: Router = inject(Router);

  ngOnInit() {
    PROGRESS_BAR_SUBJECT.subscribe({
      next: (state) => {
        this.callInProgress = state;
      }
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.isRouteLoading = true;
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.isRouteLoading = false;
      }
    });
  }
}
